import httpSSOService from "./httpSSOService";
// import authenService from "./authenService";


export default {

  // generateOTP() {
  //   return httpService.post("/otp/generateOTP");
  // },
  //
  // validateOTP(form) {
  //   return httpService.post("/otp/validateOTP", form);
  // },

  refresh() {
    return httpSSOService.post("/refreshToken/refresh");
  },
  refreshSSO() {
    let tenantCode = '';
    if(window.location.hostname) {
      tenantCode = window.location.hostname.split('.')[0];
    }
    // return httpSSOService.post("/refresh");
    return httpSSOService.post(`/refresh?tenant_code=${tenantCode}`);
  },

}





// WEBPACK FOOTER //
// ./src/services/refreshTokenService.js